import type { ValuesType } from '@fifa-bsm/bo-frontend-shared/utils/types';

export const ETicketingType = Object.freeze({
    DISABLED: 'disabled',
    STANDARD: 'standard',
    SECUTIX: 'secutix',
} as const);

export type IETicketingType = ValuesType<typeof ETicketingType>;
